"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _QuizTournamentCodeEntry = _interopRequireDefault(require("./QuizTournamentCodeEntry.scss"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _index = _interopRequireDefault(require("../Button/index.js"));

var _strings = require("../../../../config/strings");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QuizTournamentCodeEntry = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(QuizTournamentCodeEntry, _React$Component);

  var _super = _createSuper(QuizTournamentCodeEntry);

  function QuizTournamentCodeEntry(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, QuizTournamentCodeEntry);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCodeChange", function (e) {
      _this.setState({
        codeInput: e.target.value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkCode", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var styles;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.checkCodeValidity(_this.state.codeInput);

            case 2:
              console.log('wrong code');
              styles = (0, _toConsumableArray2["default"])(_this.state.checkCodeButtonStyles);

              if (!(styles.indexOf(_QuizTournamentCodeEntry["default"].buttonShake) > -1)) {
                _context.next = 7;
                break;
              }

              _this.setState({
                codeInput: ''
              });

              return _context.abrupt("return");

            case 7:
              styles.push(_QuizTournamentCodeEntry["default"].buttonShake);

              _this.setState({
                codeInput: '',
                checkCodeButtonStyles: styles
              });

              setTimeout(function () {
                var styles = (0, _toConsumableArray2["default"])(_this.state.checkCodeButtonStyles);
                var index = styles.indexOf(_QuizTournamentCodeEntry["default"].buttonShake);

                if (index > -1) {
                  console.log('REMOVING STYLE');
                  styles.splice(index, 1);

                  _this.setState({
                    checkCodeButtonStyles: styles
                  });
                }
              }, 500);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function () {
      if (_DeviceInfoHelper["default"].isiOS()) {
        window.scrollTo(0, 0);
      }
    });
    _this.state = {
      codeInput: '',
      checkCodeButtonStyles: []
    };
    return _this;
  }

  (0, _createClass2["default"])(QuizTournamentCodeEntry, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentCodeEntry["default"].mainWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentCodeEntry["default"].heading
      }, (0, _strings.getString)('ENTER_TOURNAMENT_CODE')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentCodeEntry["default"].subWrapper
      }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        onBlur: this.onBlur,
        className: _QuizTournamentCodeEntry["default"].textField,
        value: this.state.codeInput,
        label: (0, _strings.getString)('TOURNAMENT_CODE_LABEL'),
        onChange: this.onCodeChange,
        autoCorrect: 'off'
      }), /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: this.state.checkCodeButtonStyles.join(' '),
        onClick: this.checkCode,
        theme: 'blue'
      }, (0, _strings.getString)('GO_ON'))));
    }
  }]);
  return QuizTournamentCodeEntry;
}(_react["default"].Component);

QuizTournamentCodeEntry.propTypes = {
  checkCodeValidity: _propTypes["default"].func.isRequired
};
var _default = QuizTournamentCodeEntry;
exports["default"] = _default;